var _path, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgShareheart(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 15,
    viewBox: "0 0 17 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.51647 11.2683L7.89765 10.7702C5.68022 9.00433 4.21912 7.84216 4.21912 6.41586C4.21912 5.2537 5.25908 4.34056 6.58266 4.34056C7.3304 4.34056 8.04376 4.64997 8.51647 5.13295C8.98917 4.64997 9.70253 4.34056 10.4503 4.34056C11.7739 4.34056 12.8138 5.2537 12.8138 6.41586C12.8138 7.84216 11.3527 9.00433 9.13528 10.7702L8.51647 11.2683ZM2.50019 0.703125H14.5327C14.9886 0.703125 15.4259 0.862141 15.7482 1.14519C16.0706 1.42824 16.2517 1.81214 16.2517 2.21244V12.7776C16.2517 13.1779 16.0706 13.5618 15.7482 13.8449C15.4259 14.1279 14.9886 14.2869 14.5327 14.2869H2.50019C2.0443 14.2869 1.60708 14.1279 1.28471 13.8449C0.962352 13.5618 0.78125 13.1779 0.78125 12.7776V2.21244C0.78125 1.81214 0.962352 1.42824 1.28471 1.14519C1.60708 0.862141 2.0443 0.703125 2.50019 0.703125ZM2.50019 2.21244V12.7776H14.5327V2.21244H2.50019Z",
    fill: "url(#paint0_linear_4818_126899)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4818_126899",
    x1: 8.51647,
    y1: -1.74196,
    x2: 8.51647,
    y2: 16.4603,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FACB30"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.302269,
    stopColor: "#FEF9C8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.640625,
    stopColor: "#C49530"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF8C4"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgShareheart);
export default __webpack_public_path__ + "static/media/shareheart.6417a91e44a24a16a367911323c4a1df.svg";
export { ForwardRef as ReactComponent };